module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00609.ec85e6ed.jpg";